export default new class ProductDescription {
    constructor() {
        this.scrollBtn = '.js-smoth-scroll';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', this.scrollBtn, (e) => {
            e.preventDefault();

            let id = $(e.target).attr('href'),
                $body = $('body'),
                scrollToElem = $body.find(`#${id}`),
                scrollToElemOffset = scrollToElem.offset(),
                filterHeight = 75;

            $('body, html').delay('50').animate({scrollTop: scrollToElemOffset.top - filterHeight}, '500');
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/product-description/product-description.js